import config from '@/assets/js/config'
import axios from '@/assets/libs/ajax'
import qs from 'qs';

let baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro;

export const getOption = () => {
    return axios.ajax({
        url: "./allMap/locations.json",
        method: 'get',
    })
};
export const getTxtJson = () => {
    return axios.ajax({
        url: "./allMap/test.txt",
        method: 'get',
    })
};
export const getMapJson = (url) => {
    log(url)
    return axios.ajax({
        url: url,
        method: 'get',
        headers: {
            "Content-Type": "application/json;charset=utf-8"
        }
    })
};
export const convertData = (sourceData) => {
    return [].concat.apply([], $.map(sourceData, function(busLine, index) {
        var prevPoint = null;
        var points = [];
        var value = busLine.shift();
        for (var i = 0; i < busLine.length; i += 2) {
            var point = [busLine[i], busLine[i + 1]];
            if (i > 0) {
                point = [
                    prevPoint[0] + point[0],
                    prevPoint[1] + point[1]
                ];
            }
            prevPoint = point;

            points.push([point[0] / 1e5, point[1] / 1e5]);
        }
        return {
            value: value,
            coords: points
        };
    }));
}
